export const actions = {
  increase() {
    return new Promise((resolve) => {
      this.$state.requestsRunning++
      resolve(true)
    });
  },
  decrease() {
    return new Promise((resolve) => {
      if (this.$state.requestsRunning > 0) {
        setTimeout(() => {
          this.$state.requestsRunning--;
        }, 500);
      }
      resolve(true)
    });
  }
}
